module.exports = __webpack_public_path__ + "media/images/pyramid-30dfd662.png";